import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

//services
import { PortalSettingsService } from '../../../core/services/portal-settings.service';
import { EmployeeService } from '../../employee/services/employee.service';
import { HiringService } from '../../hiring/services/hiring.service';
import { UtilityService } from 'src/app/core/services/utility.service';

@Component({
  selector: 'app-emergency-contacts',
  templateUrl: './emergency-contacts.component.html',
  styleUrls: ['./emergency-contacts.component.css']
})
export class EmergencyContactsComponent implements OnInit {
  @ViewChild('rowContact', { static: false }) rowContact: NgForm;
  portalSettings: any;
  formData: { [key: string]: any } = {};
  phoneMask: any;
  country: string;
  oNECTaskCustomText: string;
  relationshipList: any[] = [];
  stateList: any[] = [];
  contactList: any[] = [];
  lastSave: { [key: string]: any } = {};

  constructor(portalSettingsService: PortalSettingsService, private employeeService: EmployeeService, private hiringService: HiringService, private utilityService: UtilityService) {
    this.portalSettings = portalSettingsService.getPortalSettings();
  }

  ngOnInit(): void {
    this.formData = {};
    this.phoneMask = this.portalSettings.PhoneMask.ConfigValue ? this.portalSettings.PhoneMask.ConfigValue.replace(/9/g, '_') : "";
    this.country = this.portalSettings.CountryDateCode.ConfigValue;
    this.formData.expendAddNew = false;
    this.oNECTaskCustomText = this.portalSettings.ONECTaskCustomText.ConfigValue;
    this.getRelationship();
    this.getState();
    this.getContact();
  }

  getRelationship(){
    this.employeeService.getECRelationship().then((response: any[]) => {
      if(response != null){
        this.relationshipList = response;
      }
    });
  }
  
  getState(){
    this.hiringService.getDependentLookupByColumnName("State", this.country).then((response: any[]) => {
      if(response != null){
        this.stateList = response;
      }
    });
  }
  
  getContact(){
    this.hiringService.getOnboardEmergencyContacts().then((response: any[]) => {
      if(response != null){
        this.contactList = response;
      }          
    });
  }

  expendRow(data: any) { 
    data.Expended = !data.Expended;
  }

  addNewContact() {
    this.hiringService.saveOnboardEmergencyContact(-1,this.formData.ContactName,this.formData.Relationship,this.formData.HomePhone,this.formData.WorkPhone,this.formData.Address,this.formData.City,this.formData.State,this.formData.Zip,this.formData.CellPhone,
      this.formData.Note).then((response: any) => {
        if(response != null){
          this.fadeLabel(response.success);
          if (response.success) {
            this.formData.ContactName = null; 
            this.formData.Relationship = null; 
            this.formData.HomePhone = null; 
            this.formData.WorkPhone = null;
            this.formData.Address = null; 
            this.formData.City = null; 
            this.formData.State = null; 
            this.formData.Zip = null; 
            this.formData.CellPhone = null; 
            this.formData.Note = null;
            this.getContact();
            this.formData.expendAddNew = false;
          }
        }
      });
  }

  deleteContact(data: any) {
    this.hiringService.deleteOnboardEmergencyContact(data.OnboardEmergencyContactID).then((response: any) => {
      if(response != null){
        this.fadeLabel(response.success);
      if (response.success) {
          this.getContact();
      }
      }
    });
  }

  saveContact(data: any) {
    this.hiringService.saveOnboardEmergencyContact(data.OnboardEmergencyContactID,data.ContactName,data.Relationship,data.HomePhone,data.WorkPhone,data.Address,data.City,data.State,data.Zip,data.CellPhone,data.Note).then((response: any) => {
      if(response != null){
        this.fadeLabel(response.success);
      }
    });        
  }

  expendAddNew() {
    this.formData.expendAddNew = !this.formData.expendAddNew;
  }

  fadeLabel(status: any) {
    this.formData.labelFade = false;    
    this.lastSave = this.utilityService.fadeLabel(status);
    setTimeout(() => {
      this.formData.labelFade = true;
    }, 2000);
  }

  updateZip(value: string, data: any) {
    data.Zip = value;
  }

  updatePhone(data: any, field: any) { 
    switch (field) {
      case 'HomePhone':
        this.formData.HomePhone = data;
        break;
      case 'CellPhone':
        this.formData.CellPhone = data;
        break;
      case 'WorkPhone':
        this.formData.WorkPhone = data;
        break;  
    }
  }

  updateRowPhone(row: any, data: any, field: any) { 
    switch (field) {
      case 'HomePhone':
        row.HomePhone = data;
        break;
      case 'CellPhone':
        row.CellPhone = data;
        break;
      case 'WorkPhone':
        row.WorkPhone = data;
        break;  
    }
  }

}